
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { FeedbackRequestForm } from '@/components/feedback';
import { Mail, Clock, Info } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

const RequestFeedback = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-gray-50">
        <div className="container mx-auto px-4 pt-8">
          <div className="flex flex-col md:flex-row items-center mb-6 gap-3">
            <div className="w-12 h-12 rounded-full bg-brandBlue/10 flex items-center justify-center text-brandBlue">
              <Mail size={24} />
            </div>
            <div>
              <h1 className="text-3xl font-bold">
                Demander un feedback
              </h1>
              <p className="text-gray-600 mt-1">
                Créez une demande personnalisée pour recevoir un retour constructif
              </p>
            </div>
          </div>
          
          <div className="mb-8 bg-blue-50 rounded-lg p-4 border border-blue-100">
            <h2 className="font-semibold text-blue-800 mb-2 flex items-center">
              <Clock className="h-5 w-5 mr-2" />
              Quand demander un feedback ?
            </h2>
            <ul className="list-disc list-inside text-blue-700 space-y-1">
              <li>Après un processus de recrutement</li>
              <li>Suite à une collaboration avec un client ou un freelance</li>
              <li>Pour améliorer vos pratiques professionnelles</li>
              <li>Dans le cadre d'une évaluation de performance</li>
            </ul>
          </div>
          
          <Alert className="mb-8 bg-amber-50 border-amber-200">
            <Info className="h-4 w-4 text-amber-700" />
            <AlertTitle className="text-amber-800">Bon à savoir</AlertTitle>
            <AlertDescription className="text-amber-700">
              Le destinataire recevra un email l'invitant à vous fournir un feedback structuré sur FeedMyBack. 
              Vous serez notifié lorsqu'il aura répondu.
            </AlertDescription>
          </Alert>
        </div>
        
        <div className="container mx-auto px-4 pb-8">
          <FeedbackRequestForm />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RequestFeedback;
